import React from "react";
import styled from "styled-components";

const Container = styled.div`
  background-color: lightslategray;
  color: white;
  padding: 3em 0;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1em;
`;

const StepsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); // Default to two columns
  gap: 2em;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr; // Switch to one column on smaller screens
    padding: 16px
  }
`;

const Step = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
  }
`;

const StepIcon = styled.div`
  background-color: orangered;
  color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
`;

const StepTitle = styled.h3`
  color: #333;
`;

const StepDescription = styled.p`
  color: #666;
`;

const WhyChooseUs = () => {
  return (
    <Container>
      <Title>Why Choose to Go Clutch For Car Service In Hyderabad?</Title>
      <StepsContainer>
        <Step>
          <StepIcon>🔧</StepIcon>
          <StepTitle>Expert Technicians</StepTitle>
          <StepDescription>
            Our skilled mechanics are dedicated to ensuring your vehicle
            receives top-notch care and attention.
          </StepDescription>
        </Step>
        <Step>
          <StepIcon>🛠️</StepIcon>
          <StepTitle>Comprehensive Car Services:</StepTitle>
          <StepDescription>
            From routine maintenance to complex repairs, we cover it all to keep
            your car running smoothly.
          </StepDescription>
        </Step>
        <Step>
          <StepIcon>💼</StepIcon>
          <StepTitle>Transparent Pricing</StepTitle>
          <StepDescription>
            No hidden costs! Enjoy clear, upfront pricing for every Car service,
            providing you with peace of mind.
          </StepDescription>
        </Step>
        <Step>
          <StepIcon>🕒</StepIcon>
          <StepTitle>Timely Car Service:</StepTitle>
          <StepDescription>
            We understand the value of your time. Count on us for efficient and
            prompt car servicing.
          </StepDescription>
        </Step>
        {/* <Step>
          <StepIcon>🛡️</StepIcon>
          <StepTitle>Quality Assurance:</StepTitle>
          <StepDescription>
            We prioritize quality in every aspect of our service, promising
            reliability and satisfaction.
          </StepDescription>
        </Step> */}
      </StepsContainer>
    </Container>
  );
};

export default WhyChooseUs;
